"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
const services_1 = require("./services");
const controllers_1 = require("./controllers");
const defaultOpts = {
    apiUrl: constants_1.API_URL,
};
class Client {
    constructor(options = {}) {
        this.instanceController = {};
        const currentOpts = Object.assign(Object.assign({}, defaultOpts), options);
        this.apiUrl = currentOpts.apiUrl;
        this.instance = this.createAxiosInstance(currentOpts.apiUrl);
    }
    // Create a new axios instance
    createAxiosInstance(baseURL) {
        const instance = axios_1.default.create({
            baseURL,
            xsrfCookieName: 'THE-HIVE-XSRF-TOKEN',
            xsrfHeaderName: 'X-THE-HIVE-XSRF-TOKEN',
            withCredentials: true,
        });
        return instance;
    }
    getBuilder() {
        return services_1.ElasticBuilder.getInstance();
    }
    getSender() {
        return services_1.AxiosSender.getInstance(this.apiUrl);
    }
    getInstanceController(key, buildInstance) {
        if (!this.instanceController[key]) {
            this.instanceController[key] = buildInstance();
        }
        return this.instanceController[key];
    }
    addInterceptor(onResolved, onRejected) {
        const axiosSender = this.getSender();
        axiosSender.getInterceptors().response.use(onResolved, onRejected);
        this.instance.interceptors.response.use(onResolved, onRejected); //! not beautifull for the moment
    }
    get AlertController() {
        return this.getInstanceController('AlertController', () => new controllers_1.AlertController(this.getBuilder(), this.getSender()));
    }
    get AlertStatusController() {
        return this.getInstanceController('AlertStatusController', () => new controllers_1.AlertStatusController(this.getBuilder(), this.getSender()));
    }
    get AnalyzerController() {
        return this.getInstanceController('AnalyzerController', () => new controllers_1.AnalyzerController(this.getBuilder(), this.getSender()));
    }
    get AnalyzerTemplateController() {
        return this.getInstanceController('AnalyzerTemplateController', () => new controllers_1.AnalyzerTemplateController(this.getBuilder(), this.getSender()));
    }
    get AttachmentController() {
        return this.getInstanceController('AttachmentController', () => new controllers_1.AttachmentController(this.getBuilder(), this.getSender()));
    }
    get AttackPatternsController() {
        return this.getInstanceController('AttackPatternsController', () => new controllers_1.AttackPatternsController(this.getBuilder(), this.getSender()));
    }
    get AuditController() {
        return this.getInstanceController('AuditController', () => new controllers_1.AuditController(this.getBuilder(), this.getSender()));
    }
    get AuthController() {
        return this.getInstanceController('AuthController', () => new controllers_1.AuthController(this.getBuilder(), this.getSender()));
    }
    get AuthProviderController() {
        return this.getInstanceController('AuthProviderController', () => new controllers_1.AuthProviderController(this.getBuilder(), this.getSender()));
    }
    get BrandingController() {
        return this.getInstanceController('BrandingController', () => new controllers_1.BrandingController(this.getBuilder(), this.getSender()));
    }
    get CaseController() {
        return this.getInstanceController('CaseController', () => new controllers_1.CaseController(this.getBuilder(), this.getSender()));
    }
    get CaseTemplateController() {
        return this.getInstanceController('CaseTemplateController', () => new controllers_1.CaseTemplateController(this.getBuilder(), this.getSender()));
    }
    get CatalogPatternController() {
        return this.getInstanceController('CatalogPatternController', () => new controllers_1.CatalogPatternController(this.getBuilder(), this.getSender()));
    }
    get ChartController() {
        return this.getInstanceController('ChartController', () => new controllers_1.ChartController(this.getBuilder(), this.getSender()));
    }
    get CommentController() {
        return this.getInstanceController('CommentController', () => new controllers_1.CommentController(this.getBuilder(), this.getSender()));
    }
    get ConfigController() {
        return this.getInstanceController('ConfigController', () => new controllers_1.ConfigController(this.getBuilder(), this.getSender()));
    }
    get CortexController() {
        return this.getInstanceController('CortexController', () => new controllers_1.CortexController(this.getBuilder(), this.getSender()));
    }
    get CustomFieldController() {
        return this.getInstanceController('CustomFieldController', () => new controllers_1.CustomFieldController(this.getBuilder(), this.getSender()));
    }
    get CustomStatusController() {
        return this.getInstanceController('CustomStatusController', () => new controllers_1.CustomStatusController(this.getBuilder(), this.getSender()));
    }
    get CustomTagController() {
        return this.getInstanceController('CustomTagController', () => new controllers_1.CustomTagController(this.getBuilder(), this.getSender()));
    }
    get DashboardController() {
        return this.getInstanceController('DashboardController', () => new controllers_1.DashboardController(this.getBuilder(), this.getSender()));
    }
    get DescribeController() {
        return this.getInstanceController('DescribeController', () => new controllers_1.DescribeController(this.getBuilder(), this.getSender()));
    }
    get ExportController() {
        return this.getInstanceController('ExportController', () => new controllers_1.ExportController(this.getBuilder(), this.getSender()));
    }
    get ForgetPasswordController() {
        return this.getInstanceController('ForgetPasswordController', () => new controllers_1.ForgetPasswordController(this.getBuilder(), this.getSender()));
    }
    get FunctionController() {
        return this.getInstanceController('FunctionController', () => new controllers_1.FunctionController(this.getBuilder(), this.getSender()));
    }
    get LicenseController() {
        return this.getInstanceController('LicenseController', () => new controllers_1.LicenseController(this.getBuilder(), this.getSender()));
    }
    get MailerController() {
        return this.getInstanceController('MailerController', () => new controllers_1.MailerController(this.getBuilder(), this.getSender()));
    }
    get MispController() {
        return this.getInstanceController('MispController', () => new controllers_1.MispController(this.getBuilder(), this.getSender()));
    }
    get NotificationController() {
        return this.getInstanceController('NotificationController', () => new controllers_1.NotificationController(this.getBuilder(), this.getSender()));
    }
    get ObservableController() {
        return this.getInstanceController('ObservableController', () => new controllers_1.ObservableController(this.getBuilder(), this.getSender()));
    }
    get ObservableTypeController() {
        return this.getInstanceController('ObservableTypeController', () => new controllers_1.ObservableTypeController(this.getBuilder(), this.getSender()));
    }
    get OrganisationController() {
        return this.getInstanceController('OrganisationController', () => new controllers_1.OrganisationController(this.getBuilder(), this.getSender()));
    }
    get PageController() {
        return this.getInstanceController('PageController', () => new controllers_1.PageController(this.getBuilder(), this.getSender()));
    }
    get PageTemplateController() {
        return this.getInstanceController('PageTemplateController', () => new controllers_1.PageTemplateController(this.getBuilder(), this.getSender()));
    }
    get PlatformStatusController() {
        return this.getInstanceController('PlatformStatusController', () => new controllers_1.PlatformStatusController(this.getBuilder(), this.getSender()));
    }
    get ProcedureController() {
        return this.getInstanceController('ProcedureController', () => new controllers_1.ProcedureController(this.getBuilder(), this.getSender()));
    }
    get ProfileController() {
        return this.getInstanceController('ProfileController', () => new controllers_1.ProfileController(this.getBuilder(), this.getSender()));
    }
    get ReportTemplateController() {
        return this.getInstanceController('ReportTemplateController', () => new controllers_1.ReportTemplateController(this.getBuilder(), this.getSender()));
    }
    get ResponderController() {
        return this.getInstanceController('ResponderController', () => new controllers_1.ResponderController(this.getBuilder(), this.getSender()));
    }
    get SearchController() {
        return this.getInstanceController('SearchController', () => new controllers_1.SearchController(this.getBuilder(), this.getSender()));
    }
    get SessionController() {
        return this.getInstanceController('SessionController', () => new controllers_1.SessionController(this.getBuilder(), this.getSender()));
    }
    get StatusController() {
        return this.getInstanceController('StatusController', () => new controllers_1.StatusController(this.getBuilder(), this.getSender()));
    }
    get StreamController() {
        return this.getInstanceController('StreamController', () => new controllers_1.StreamController(this.getBuilder(), this.getSender()));
    }
    get StreamLongPollingController() {
        return this.getInstanceController('StreamLongPollingController', () => new controllers_1.StreamLongPollingController(this.getBuilder(), this.getSender()));
    }
    get TaskController() {
        return this.getInstanceController('TaskController', () => new controllers_1.TaskController(this.getBuilder(), this.getSender()));
    }
    get TaskLogController() {
        return this.getInstanceController('TaskLogController', () => new controllers_1.TaskLogController(this.getBuilder(), this.getSender()));
    }
    get TaxonomyController() {
        return this.getInstanceController('TaxonomyController', () => new controllers_1.TaxonomyController(this.getBuilder(), this.getSender()));
    }
    get TimelineController() {
        return this.getInstanceController('TimelineController', () => new controllers_1.TimelineController(this.getBuilder(), this.getSender()));
    }
    get UISettingsController() {
        return this.getInstanceController('UISettingsController', () => new controllers_1.UISettingsController(this.getBuilder(), this.getSender()));
    }
    get UserController() {
        return this.getInstanceController('UserController', () => new controllers_1.UserController(this.getBuilder(), this.getSender()));
    }
}
exports.default = Client;
